'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _templateObject = _taggedTemplateLiteral(['', ''], ['', '']),
    _templateObject2 = _taggedTemplateLiteral(['\n\t\tanimation-name: ', ';\n\t\tanimation-duration: ', 'ms;\n\t\tanimation-iteration-count: ', ';\n\t\tdisplay: \'inline-block\';\n\t\ttransform-origin: ', ';\n\t\t\n\t\t&', ' {\n\t\t\tanimation-name: ', ';\n\t\t\tanimation-play-state: ', ';\n\t\t\tanimation: ', ';\n\t\t}\n\t\t\n\t\tanimation-play-state: ', ';\n\t'], ['\n\t\tanimation-name: ', ';\n\t\tanimation-duration: ', 'ms;\n\t\tanimation-iteration-count: ', ';\n\t\tdisplay: \'inline-block\';\n\t\ttransform-origin: ', ';\n\t\t\n\t\t&', ' {\n\t\t\tanimation-name: ', ';\n\t\t\tanimation-play-state: ', ';\n\t\t\tanimation: ', ';\n\t\t}\n\t\t\n\t\tanimation-play-state: ', ';\n\t']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Shake = function Shake(_ref) {
	var _ref$h = _ref.h,
	    h = _ref$h === undefined ? 5 : _ref$h,
	    _ref$v = _ref.v,
	    v = _ref$v === undefined ? 5 : _ref$v,
	    _ref$r = _ref.r,
	    r = _ref$r === undefined ? 3 : _ref$r,
	    _ref$dur = _ref.dur,
	    dur = _ref$dur === undefined ? 300 : _ref$dur,
	    _ref$q = _ref.q,
	    q = _ref$q === undefined ? 'infinite' : _ref$q,
	    _ref$tf = _ref.tf,
	    tf = _ref$tf === undefined ? 'ease-in-out' : _ref$tf,
	    _ref$int = _ref.int,
	    int = _ref$int === undefined ? 10 : _ref$int,
	    _ref$max = _ref.max,
	    max = _ref$max === undefined ? 100 : _ref$max,
	    _ref$orig = _ref.orig,
	    orig = _ref$orig === undefined ? 'center center' : _ref$orig,
	    _ref$fixed = _ref.fixed,
	    fixed = _ref$fixed === undefined ? false : _ref$fixed,
	    _ref$freez = _ref.freez,
	    freez = _ref$freez === undefined ? false : _ref$freez,
	    _ref$active = _ref.active,
	    active = _ref$active === undefined ? true : _ref$active,
	    _ref$trigger = _ref.trigger,
	    trigger = _ref$trigger === undefined ? ':hover' : _ref$trigger,
	    _ref$fixedStop = _ref.fixedStop,
	    fixedStop = _ref$fixedStop === undefined ? false : _ref$fixedStop,
	    _ref$elem = _ref.elem,
	    elem = _ref$elem === undefined ? 'div' : _ref$elem,
	    props = _objectWithoutProperties(_ref, ['h', 'v', 'r', 'dur', 'q', 'tf', 'int', 'max', 'orig', 'fixed', 'freez', 'active', 'trigger', 'fixedStop', 'elem']);

	var random = function random(max) {
		var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

		return Math.random() * (max - min) - max / 2;
	};

	var doKeyframes = function doKeyframes() {
		// el objecto que iremos llenando
		var kf = {};
		var init = 'translate(0,0) rotate(0)';

		// loop con intervalos basados en `int`
		for (var st = int; st <= max; st += int) {
			// Numeros aleatorios en cada keyframe
			var x = random(h);
			var y = random(v);
			var rot = random(r);

			kf[st + '%'] = {
				transform: 'translate(' + x + 'px, ' + y + 'px) rotate(' + rot + 'deg)'
			};
		}

		// Init de las transformaciones en 0% y 100%
		kf['0%'] = kf[Math.min(max, 100) + '%'] = {
			transform: init
		};

		return kf;
	};

	// Creamos los `@keyframes`
	var kf = doKeyframes();

	var toString = function toString(obj) {
		return Object.keys(obj).reduce(function (acc, next) {
			return acc + '\n\t\t\t' + next + ' {\n\t\t\t\ttransform: ' + obj[next].transform + '\n\t\t\t}';
		}, '');
	};

	var shakeKeyframes = (0, _styledComponents.keyframes)(_templateObject, toString(kf));
	var shouldShakeDefault = fixed || !fixed && freez;
	var shouldShakeWhenTriggered = !fixed && !freez;

	var ShakeComp = _styledComponents2.default[elem](_templateObject2, shouldShakeDefault && shakeKeyframes, dur, q, orig, trigger, shouldShakeWhenTriggered && shakeKeyframes, freez && (!fixed ? 'running' : 'paused'), fixed && fixedStop && 'initial', freez && (!fixed ? 'paused' : 'running'));

	return _react2.default.createElement(
		ShakeComp,
		props,
		props.children
	);
};

exports.default = Shake;


//////////////////
// WEBPACK FOOTER
// ./node_modules/reshake/dist/Shake.js
// module id = 14
// module chunks = 0